export const loginType = {
    email: 0,
    socialSite: 1,
}

export const convertToSlug = (Text) => {
    return Text.toLowerCase()
        .replace(/[^\w ]+/g, '')
        .replace(/ +/g, '-');
}